/** @format */

import banner1TH from "../../assets/Banner-TH1.png";
import banner2TH from "../../assets/Banner-TH2.png";
import banner3TH from "../../assets/Banner-TH3.png";

import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "../../css/Banner.css";
import { propTypes } from "react-bootstrap/esm/Image";

export default function BannerTH(props) {
  const [lang, setLanguage] = useState(true);

  const changeLang = () => {
    props.onSelect(!lang);
    // setLanguage(!lang)
    // console.log(lang);
  };

  return (
    <div
      id="carouselExampleIndicators"
      class="col-sm-12 carousel slide mt-0"
      data-bs-ride="carousel">
      <div class="carousel-indicators">
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="0"
          class="active"
          aria-current="true"
          aria-label="Slide 1"></button>
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="1"
          aria-label="Slide 2"></button>
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="2"
          aria-label="Slide 3"></button>
      </div>
      <div class="carousel-inner" role="listbox">
        <div class="carousel-item active">
          <img className="banner" src={banner1TH} alt="banner1TH" />
        </div>
        <div class="carousel-item">
          <img className="banner" src={banner2TH} alt="banner2TH" />
        </div>
        <div class="carousel-item">
          <img className="banner" src={banner3TH} alt="banner3TH" />
        </div>
      </div>
      <button
        class="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        class="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  );
}
